import {
  COUNCIL_REPORT_PAGE_SLUGS,
  ROAD_MAINTENANCE_INDEX,
  pressReleases,
} from '@fixtyer/content';

const CORE_INDEXABLE_PATHS = [
  '/',
  '/about',
  '/how-it-works',
  '/meet-mac',
  '/pricing',
  '/sample-council-claim-pack',
  '/faq',
  '/support',
  '/media-enquiries',
  '/privacy',
  '/terms',
  '/cookies',
  '/road-maintenance-report',
  '/authority-ratings',
  '/data/council-road-maintenance-ratings',
  '/pothole-hall-of-shame',
  '/councils',
  '/guides',
  '/road-maintenance-index',
  '/crawler-and-citation-access',
  '/press',
] as const;

const BLOG_SLUGS = [
  'new-year-same-potholes',
  'what-evidence-do-you-need-for-pothole-damage-claim',
  'spring-pothole-season',
  'council-rejected-your-pothole-claim',
  'mechanics-view-hidden-pothole-damage',
  'summer-road-trips-pothole-damage',
] as const;

export const GUIDE_SLUGS = [
  'national-highways-pothole-claims',
  'england-wales-pothole-claims',
  'request-road-inspection-records',
  'council-claim-or-car-insurance',
  'dashcam-pothole-evidence',
  'pothole-claim-rejected-next-steps',
  'highway-authority-claim-routes',
  'what-makes-a-valid-claim',
  'who-is-responsible',
  'claim-timeline',
  'fix-my-street-pothole-reporting',
  'photographing-pothole-damage',
  'documenting-vehicle-damage',
  'getting-repair-quotes',
  'pothole-claim-letter-template',
  'section-41-explained',
  'section-58-defence',
  'prior-reports-explained',
  'understanding-rejection-reasons',
  'small-claims-court-guide',
  'what-to-expect-at-hearing',
] as const;

const SAFE_EXACT_APP_PATHS = [
  '/check',
  '/register',
  '/login',
  '/forgot-password',
  '/reset-password',
  '/dashboard',
  '/admin',
  '/claims',
  '/claims/new',
  '/contact',
  '/lp/dudley',
  '/lp/derbyshire',
  '/lp/leicestershire',
  '/lp/suffolk',
  '/lp/slough',
  '/other',
] as const;

export const INDEXABLE_PUBLIC_PATHS: readonly string[] = Object.freeze([
  ...CORE_INDEXABLE_PATHS,
  '/blog',
  ...BLOG_SLUGS.map((slug) => `/blog/${slug}`),
  ...pressReleases.map((release) => `/press/${release.slug}`),
  ...COUNCIL_REPORT_PAGE_SLUGS.map((slug) => `/councils/${slug}`),
  ...GUIDE_SLUGS.map((slug) => `/guides/${slug}`),
  ...ROAD_MAINTENANCE_INDEX.regions.map(
    (region) => `/road-maintenance-index/regions/${region.slug}`
  ),
]);

const ALLOWED_ANALYTICS_PATHS = new Set([
  ...INDEXABLE_PUBLIC_PATHS,
  ...SAFE_EXACT_APP_PATHS,
]);

export function sanitiseAnalyticsPath(path: string): string {
  const withoutQuery = path.split(/[?#]/, 1)[0] || '/';
  const withLeadingSlash = withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`;
  const candidate =
    withLeadingSlash.length > 1 ? withLeadingSlash.replace(/\/+$/, '') : withLeadingSlash;

  if (/^\/claims\/(?!new(?:\/|$))[^/]+$/.test(candidate)) {
    return '/claims/:claim_id';
  }
  if (/^\/reset-password\/[^/]+$/.test(candidate)) {
    return '/reset-password/:token';
  }
  return ALLOWED_ANALYTICS_PATHS.has(candidate) ? candidate : '/other';
}
